import { useEffect } from 'react'

import { getGroupSlug } from './helpers'

const useGroupHashing = ({ setGroupingType, trigger }: { setGroupingType: (type: 'all' | 'needsAttention') => void; trigger?: unknown }) => {
  useEffect(() => {
    const applyHash = () => {
      const hash = window.location.hash.replace('#', '')

      if (hash === getGroupSlug('needs-attention')) {
        setGroupingType('needsAttention')
        return
      }

      setGroupingType('all')
    }

    applyHash()
    window.addEventListener('hashchange', applyHash)

    return () => {
      window.removeEventListener('hashchange', applyHash)
    }
  }, [setGroupingType, trigger])
}

export default useGroupHashing
